import React, { useMemo } from 'react';
import { Icon } from '@iconify/react';

const AssigneeList = ({
  assignees,
  collapsedGroups,
  onToggleGroup,
  visibilityMap = {},
  onToggleVisibility,
  onToggleGroupVisibility,
}) => {
  const groups = useMemo(() => ['internal', 'contractor'], []);

  const contractorRowsBySupplier = useMemo(() => {
    const rows = assignees?.contractor || [];
    return rows.reduce((acc, assignee) => {
      const supplierName = assignee?.secondaryName || 'Unassigned Supplier';
      if (!acc[supplierName]) acc[supplierName] = [];
      acc[supplierName].push(assignee);
      return acc;
    }, {});
  }, [assignees?.contractor]);

  return (
    <div className='border-end bg-white' style={{ height: "calc(100vh - 240px)", overflow: "auto" }}>
      {groups.map((groupKey) => {
      const label = groupKey === 'internal' ? 'Crew' : 'Contractors';
      const rows = assignees[groupKey] || [];
      const selectedCount = rows.filter((assignee) => visibilityMap[`${assignee.type}:${assignee.id}`] !== false).length;
      const isAllSelected = rows.length > 0 && selectedCount === rows.length;
      const isIndeterminate = selectedCount > 0 && selectedCount < rows.length;

      return (
        <div key={groupKey}>
          <button
            type='button'
            className='btn btn-link text-decoration-none w-100 text-start px-2 pt-12 border-bottom bg-light d-flex align-items-center'
            onClick={() => onToggleGroup(groupKey)}
          >
            <input
              type='checkbox'
              className='form-check-input ms-8 me-8'
              checked={isAllSelected}
              ref={(input) => {
                if (input) input.indeterminate = isIndeterminate;
              }}
              onClick={(event) => event.stopPropagation()}
              onChange={() => onToggleGroupVisibility?.(groupKey, !isAllSelected)}
              disabled={rows.length === 0}
              aria-label={`Toggle ${label} visibility`}
            />
            <span className='fw-semibold small'>{label}</span>
            <span className='text-muted ms-2 small'>({rows.length})</span>
            <Icon
              icon={collapsedGroups[groupKey] ? 'mdi:chevron-down' : 'mdi:chevron-up'}
              className='ms-auto me-8 text-muted text-xl'
              aria-hidden='true'
            />
          </button>
          {!collapsedGroups[groupKey] && rows.length === 0 && (
            <div className='p-8 border-bottom small text-muted'>No assignees</div>
          )}
          {!collapsedGroups[groupKey] && groupKey !== 'contractor' && rows.map((assignee) => (
            <div key={`${groupKey}-${assignee.id}`} className='p-8 border-bottom small d-flex align-items-center gap-2' title={assignee.name}>
              <input
                type='checkbox'
                className='form-check-input text-md'
                style={{ position: "relative", top: "-2px", marginLeft: "3px" }}
                checked={visibilityMap[`${assignee.type}:${assignee.id}`] !== false}
                onChange={() => onToggleVisibility?.(assignee)}
                aria-label={`Show ${assignee.name} in calendar`}
              />
              <span className='text-truncate flex-grow-1'>
                {assignee.name}
                {assignee.secondaryName ? <span className='text-muted ms-1'>({assignee.secondaryName})</span> : null}
              </span>
            </div>
          ))}
          {!collapsedGroups[groupKey] && groupKey === 'contractor' && Object.entries(contractorRowsBySupplier).map(([supplierName, supplierRows]) => (
            <div key={`${groupKey}-supplier-${supplierName}`} className='border-bottom'>
              <div className='px-12 py-6 small fw-semibold text-secondary bg-light-subtle border-top border-bottom'>
                {supplierName}
              </div>
              {supplierRows.map((assignee) => (
                <div key={`${groupKey}-${assignee.id}`} className='p-8 border-bottom small d-flex align-items-center gap-2' title={assignee.name}>
                  <input
                    type='checkbox'
                    className='form-check-input text-md'
                    style={{ position: "relative", top: "-2px", marginLeft: "3px" }}
                    checked={visibilityMap[`${assignee.type}:${assignee.id}`] !== false}
                    onChange={() => onToggleVisibility?.(assignee)}
                    aria-label={`Show ${assignee.name} in calendar`}
                  />
                  <span className='text-truncate flex-grow-1'>
                    {assignee.name}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      );
      })}
    </div>
  );
};

export default AssigneeList;
